import { render, staticRenderFns } from "./AlfaTargetsAndLimits.vue?vue&type=template&id=2e165f99&scoped=true&"
import script from "./AlfaTargetsAndLimits.vue?vue&type=script&lang=js&"
export * from "./AlfaTargetsAndLimits.vue?vue&type=script&lang=js&"
import style0 from "./AlfaTargetsAndLimits.vue?vue&type=style&index=0&id=2e165f99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e165f99",
  null
  
)

export default component.exports